import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

export function signUp(email, password , captcha) {
    //axios call
    const postData = {
        email,
        password,
        captcha,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

// export function login(email, password) {
//     const postData = {
//         email,
//         password,
//         returnSecureToken: true,
//     };
//     return axios.post(
//         `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
//         postData,
//     );
// }

export function login(UserName, Password , captcha) {
    const postData = {
        UserName,
        Password,
        captcha,
    };
    return axios.post(
        `https://core.pskeromais.com.br/api/v1/login`,
        postData,
        {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
        },
    );
}

export function formatError(errorResponse) {
    if (!errorResponse?.error?.message) {
        return 'Erro ao realizar login. Verifique suas credenciais.';
    }

    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            swal("Ops", "Este email já está cadastrado", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            swal("Ops", "Email não encontrado", "error", { button: "Tentar Novamente!" });
            break;
        case 'INVALID_PASSWORD':
            swal("Ops", "Senha inválida", "error", { button: "Tentar Novamente!" });
            break;
        case 'USER_DISABLED':
            swal("Ops", "Usuário desativado", "error", { button: "Tentar Novamente!" });
            break;
        default:
            swal("Ops", "Erro ao realizar login. Verifique suas credenciais.", "error", { button: "Tentar Novamente!" });
            break;
    }
    return '';
}

export function saveTokenInLocalStorage(tokenDetails , name) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + 3600 * 1000,
    );
    tokenDetails.idToken = tokenDetails.data 
    tokenDetails.expiresIn = "3600" 
    tokenDetails.refreshToken = tokenDetails.data 
    tokenDetails.registered = true 
    tokenDetails.name = name 
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));
	
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}
